import { WebDemuxer } from 'web-demuxer'

const STANDARD_FPS = [23.976, 24, 25, 29.97, 30, 50, 59.94, 60]

function parseFraction(str) {
	if (!str) return null
	const parts = str.split('/')
	if (parts.length === 2) {
		const num = parseInt(parts[0], 10)
		const den = parseInt(parts[1], 10)
		if (den > 0 && !isNaN(num)) return num / den
	}
	const n = parseFloat(str)
	return isNaN(n) ? null : n
}

function roundToStandardFps(raw) {
	let best = raw
	let bestDist = Infinity
	for (const std of STANDARD_FPS) {
		const dist = Math.abs(raw - std)
		if (dist < bestDist) {
			bestDist = dist
			best = std
		}
	}
	return bestDist < 0.5 ? best : null
}

export async function detectFps(file) {
	const wasmUrl = new URL('/web-demuxer.wasm', window.location.origin).href
	const demuxer = new WebDemuxer({ wasmFilePath: wasmUrl })
	try {
		await demuxer.load(file)
		const stream = await demuxer.getMediaStream('video')

		const rFps = parseFraction(stream.r_frame_rate)
		const avgFps = parseFraction(stream.avg_frame_rate)
		const frameCount = parseInt(stream.nb_frames, 10) || 0

		if (rFps && avgFps && Math.abs(rFps - avgFps) > 1) {
			return { fps: null, frameCount }
		}

		const fps = rFps ? roundToStandardFps(rFps) : null
		return { fps, frameCount }
	} catch (e) {
		console.error('[VideoFPS] detectFps error:', e)
		return { fps: null, frameCount: 0 }
	} finally {
		demuxer.destroy()
	}
}
